import './style/index.less';
import WebsocketMsgConfig from './WebsocketMsgConfig';
export default WebsocketMsgConfig;
